module.exports = __webpack_public_path__ + "media/images/handstand-ed25ac5249a02637a1eb0ea7f1e4f101.png";